/* DISTINCT white - comportamento del sito */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var viewer = doc.getElementById('viewer');
  var vbody = doc.getElementById('viewerBody');
  var toast = doc.getElementById('toast');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isOpen = false;
  var lastTrigger = null;
  var toastTimer = 0;

  /* --------------------------------------------------------------- menu */
  var menu = doc.getElementById('menu');
  var burger = doc.querySelector('[data-menu-toggle]');
  function setMenu(open) {
    if (!menu || !burger) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if ('inert' in menu) menu.inert = !open;
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Chiudi il menu' : 'Apri il menu');
    root.classList.toggle('menu-open', open);
    if (open) {
      var first = menu.querySelector('a');
      if (first) setTimeout(function () { if (menu.classList.contains('is-open')) first.focus({ preventScroll: true }); }, 400);
    }
  }
  if (burger) burger.addEventListener('click', function () { setMenu(!menu.classList.contains('is-open')); });
  doc.querySelectorAll('[data-menu-close]').forEach(function (a) {
    a.addEventListener('click', function () { setMenu(false); });
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && menu.classList.contains('is-open')) { setMenu(false); burger.focus(); }
  });
  window.addEventListener('resize', function () { if (window.innerWidth > 720) setMenu(false); });

  /* -------------------------------------------------------------- toast */
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 2200);
  }

  function updateCount(n) {
    doc.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n < 1; });
  }

  /* ------------------------------------------------- foto che escono */
  function prefetch(id) {
    var tpl = doc.getElementById(id);
    if (!tpl || !tpl.content || tpl.getAttribute('data-pf')) return;
    tpl.setAttribute('data-pf', '1');
    var imgs = tpl.content.querySelectorAll('img');
    for (var i = 0; i < imgs.length && i < 4; i++) {
      var im = new Image();
      im.src = imgs[i].getAttribute('src');
    }
  }

  function burst(source) {
    var slides = [].slice.call(vbody.querySelectorAll('.vw__slide'));
    var head = vbody.querySelector('.vw__head');
    var buy = vbody.querySelector('.vw__buy');
    var nav = vbody.querySelector('.vw__nav');
    if (reduce || !viewer.animate || !slides.length) return;

    var from = source.querySelector('.drop__img') || source.querySelector('.card__media') || source;
    var fr = from.getBoundingClientRect();
    var cx = fr.left + fr.width / 2;
    var cy = fr.top + fr.height / 2;

    viewer.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
    [head, buy, nav].forEach(function (n) {
      if (n) n.animate([{ opacity: 0 }, { opacity: 0, offset: .4 }, { opacity: 1 }], { duration: 800, easing: 'ease-out' });
    });

    var r = slides[0].getBoundingClientRect();
    var dx = cx - (r.left + r.width / 2);
    var dy = cy - (r.top + r.height / 2);
    var s = Math.min(.6, (fr.width * .6) / Math.max(r.width, 1));
    slides[0].animate([
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ') rotate(-6deg)', opacity: 0 },
      { opacity: 1, offset: .25 },
      { transform: 'none', opacity: 1 }
    ], { duration: 950, easing: 'cubic-bezier(.16,1,.3,1)' });

    slides.slice(1, 3).forEach(function (el, i) {
      el.animate([
        { transform: 'translateX(' + (70 + i * 40) + 'px)', opacity: 0 },
        { transform: 'none', opacity: 1 }
      ], { duration: 800, delay: 380 + i * 130, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
    });
  }

  /* --------------------------------------------- carosello: una foto alla volta */
  function initSlider(scope) {
    var st = scope.querySelector('[data-slider]');
    if (!st || st.__api) return;
    var track = st.querySelector('.vw__track');
    var slides = [].slice.call(st.querySelectorAll('.vw__slide'));
    var n = slides.length;
    var dotsBox = st.querySelector('.vw__dots');
    var count = st.querySelector('.vw__count');
    var prev = st.querySelector('[data-slide="-1"]');
    var next = st.querySelector('[data-slide="1"]');
    var idx = 0, raf = 0;
    st.setAttribute('data-count', n);
    if (n < 2) { st.__api = { step: function () {} }; return; }

    var dots = slides.map(function (_, i) {
      var d = doc.createElement('button');
      d.type = 'button'; d.className = 'vw__dot';
      d.setAttribute('aria-label', 'Foto ' + (i + 1) + ' di ' + n);
      d.addEventListener('click', function () { go(i); });
      dotsBox.appendChild(d);
      return d;
    });

    function pad(v) { return v < 10 ? '0' + v : '' + v; }
    function current() {
      var c = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - c);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    function paint() {
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
      count.textContent = pad(idx + 1) + ' / ' + pad(n);
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === n - 1;
    }
    function go(i) {
      i = Math.max(0, Math.min(n - 1, i));
      var s = slides[i];
      track.scrollTo({ left: s.offsetLeft + s.offsetWidth / 2 - track.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
    }
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var i = current();
        if (i !== idx) { idx = i; paint(); }
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    });

    /* mouse: trascina per cambiare foto (col dito ci pensa lo scorrimento nativo) */
    var down = false, sx = 0, sl = 0, dxm = 0, si = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; sx = e.clientX; sl = track.scrollLeft; dxm = 0; si = idx;
      track.classList.add('is-drag');
      try { track.setPointerCapture(e.pointerId); } catch (er) {}
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      dxm = e.clientX - sx;
      track.scrollLeft = sl - dxm;
    });
    function endDrag() {
      if (!down) return;
      down = false;
      track.classList.remove('is-drag');
      var target = current();
      if (dxm > 50 && target >= si) target = si - 1;
      else if (dxm < -50 && target <= si) target = si + 1;
      go(target);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    st.__api = { step: function (d) { go(idx + d); } };
    paint();
  }

  function openViewer(id, source) {
    var tpl = doc.getElementById(id);
    if (!viewer || !tpl || !tpl.content) return false;

    vbody.innerHTML = '';
    vbody.appendChild(tpl.content.cloneNode(true));
    if (chosenSize) {
      [].forEach.call(vbody.querySelectorAll('.sizes input'), function (i) {
        if (!i.disabled && i.getAttribute('data-label') === chosenSize) i.checked = true;
      });
    }
    var imgs = [].slice.call(vbody.querySelectorAll('.vw__slide img'));
    imgs.slice(0, 3).forEach(function (im) { im.loading = 'eager'; });

    viewer.hidden = false;
    initSlider(vbody);
    tick();
    root.classList.add('viewer-open');
    isOpen = true;
    lastTrigger = source;

    var decodes = imgs.slice(0, 3).map(function (im) {
      return im.decode ? im.decode().catch(function () {}) : Promise.resolve();
    });
    var wait = new Promise(function (res) { setTimeout(res, 450); });
    Promise.race([Promise.all(decodes), wait]).then(function () { if (isOpen) burst(source); });

    try { history.pushState({ viewer: 1 }, '', location.href); } catch (e) {}
    var closeBtn = vbody.querySelector('[data-viewer-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
    return true;
  }

  function closeViewer(fromPop) {
    if (!isOpen) return;
    isOpen = false;
    function done() {
      viewer.hidden = true;
      vbody.innerHTML = '';
      root.classList.remove('viewer-open');
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
    }
    if (reduce || !viewer.animate) done();
    else {
      var a = viewer.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: 'ease-out' });
      a.onfinish = done;
    }
    if (!fromPop && history.state && history.state.viewer) history.back();
  }

  window.addEventListener('popstate', function () { if (isOpen) closeViewer(true); });
  doc.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { closeViewer(); return; }
    var st = vbody.querySelector('[data-slider]');
    if (st && st.__api && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      if (doc.activeElement && doc.activeElement.classList && doc.activeElement.classList.contains('vw__track')) return;
      st.__api.step(e.key === 'ArrowRight' ? 1 : -1);
    }
  });

  /* ------------------------------------------------------------ countdown */
  var timer = 0;
  function two(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var D = window.DROP;
    if (!D || root.classList.contains('drop-live')) return;
    var left = D.t - Date.now();
    if (left <= 0) {
      root.classList.add('drop-live');
      if (timer) { clearInterval(timer); timer = 0; }
      return;
    }
    var s = Math.floor(left / 1000);
    var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
    doc.querySelectorAll('[data-countdown]').forEach(function (el) {
      ['d', 'h', 'm', 's'].forEach(function (k) {
        var b = el.querySelector('[data-cd="' + k + '"]');
        var t = two(v[k]);
        if (b && b.textContent !== t) b.textContent = t;
      });
      var w = el.querySelector('[data-cd-when]');
      if (w && !w.textContent) w.textContent = D.when;
    });
  }
  if (window.DROP && !root.classList.contains('drop-live')) {
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------ carrello */
  var chosenSize = '';

  function setMsg(box, text, isErr, html) {
    var msg = box.querySelector('[data-msg]');
    if (!msg) return;
    msg.classList.toggle('is-err', !!isErr);
    if (html) msg.innerHTML = html; else msg.textContent = text || '';
  }

  function addToCart(btn) {
    if (btn.hasAttribute('data-drop-btn') && !root.classList.contains('drop-live')) return;
    var box = btn.closest('[data-buy]');
    if (!box) return;
    var group = box.querySelector('.sizes');
    var checked = box.querySelector('.sizes input:checked');
    var label = btn.textContent;

    if (group && !checked) {
      setMsg(box, 'Scegli la taglia', true);
      group.classList.remove('is-shake');
      void group.offsetWidth;
      group.classList.add('is-shake');
      return;
    }

    var item = { id: Number(btn.getAttribute('data-variant')), quantity: 1 };
    if (checked && group.getAttribute('data-sizes') === 'variant') item.id = Number(checked.value);
    if (checked && group.getAttribute('data-sizes') === 'prop') item.properties = { 'Taglia': checked.value };

    btn.disabled = true;
    setMsg(box, '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Errore'); });
        return r.json();
      })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        btn.textContent = 'Aggiunto';
        if (!isOpen) showToast('Aggiunto al carrello');
        setMsg(box, '', false, '<a href="/cart">Vai al carrello</a>');
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        setMsg(box, (err && err.message) || 'Non è stato possibile aggiungere il prodotto.', true);
      });
  }

  /* la taglia scelta nella home resta selezionata anche nella finestra foto */
  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('.sizes input')) return;
    chosenSize = t.getAttribute('data-label') || '';
    var box = t.closest('[data-buy]');
    if (box) setMsg(box, '');
    doc.querySelectorAll('.sizes input').forEach(function (i) {
      if (i !== t && !i.disabled && i.getAttribute('data-label') === chosenSize) i.checked = true;
    });
  });

  doc.querySelectorAll('.vw--page').forEach(initSlider);

  /* -------------------------------------------------------------- eventi */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var trigger = t.closest('[data-viewer]');
    if (trigger) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      if (openViewer(trigger.getAttribute('data-viewer'), trigger)) e.preventDefault();
      return;
    }
    if (t.closest('[data-viewer-close]')) { closeViewer(); return; }
    var add = t.closest('[data-add]');
    if (add && !add.disabled) addToCart(add);
  });

  function warm(e) {
    var a = e.target.closest && e.target.closest('[data-viewer]');
    if (a) prefetch(a.getAttribute('data-viewer'));
  }
  doc.addEventListener('pointerover', warm, { passive: true });
  doc.addEventListener('touchstart', warm, { passive: true });
  window.addEventListener('load', function () {
    setTimeout(function () {
      var hero = doc.querySelector('.drop[data-viewer]');
      if (hero) prefetch(hero.getAttribute('data-viewer'));
    }, 2500);
  });
})();
